import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { object } from 'prop-types';
import { renderRichTextReact } from '../../../utils/storyblokRichText';

const TableDataCell = ({ blok }) => (
  <div {...storyblokEditable(blok)} className="td">
    {renderRichTextReact(blok.value)}
  </div>
);

TableDataCell.propTypes = {
  blok: object.isRequired,
};

export default TableDataCell;
